import React, { useState } from 'react';
import { Box, Button, IconButton, InfoCircleIcon, LabIconsUploadIcon, Typography } from '@customink/pigment-react';
import { Tooltip, useTheme } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import { Loader } from '~/components/Loader/loader';
import { styled } from '@customink/pigment-react/lib/themeCustomink';
import { ACCEPTED_FILES_EXT, ACCEPTED_MIME_TYPES, FILE_MAX_SIZE_IN_BYTES, useUpload } from './useUpload';
import { UploadInfoDialog } from './UploadInfoDialog';

const ArtsLoadingBox = styled(Box)(({ theme }) => ({
    position: 'absolute',
    inset: 0,
    backgroundColor: theme.palette.grey[200],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const DesktopUpload: React.FC = () => {
    const [infoDialogVisible, setInfoDialogVisible] = useState(false);
    const { isPending, onUpload: onDrop } = useUpload();
    const theme = useTheme();

    const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
        onDrop,
        accept: ACCEPTED_MIME_TYPES,
        noClick: true,
        noKeyboard: true,
        maxSize: FILE_MAX_SIZE_IN_BYTES,
    });

    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Box {...getRootProps()}>
            <input {...getInputProps()} />

            <div>
                <Box
                    sx={{
                        fontSize: '2rem',
                        mb: 2,
                    }}
                >
                    <LabIconsUploadIcon fontSize="inherit" />
                </Box>
                <Typography variant="uiTextSmall" paragraph sx={{ mb: 1 }}>
                    Drag &amp; Drop
                </Typography>
                <Typography variant="uiTextSmall" paragraph sx={{ mb: 1 }}>
                    or
                </Typography>
                <Button onClick={open} sx={{ margin: 1 }}>
                    Browse your device
                </Button>
                <br />
                <Tooltip title="Upload Requirements" placement="right">
                    <IconButton
                        sx={{ mt: 1, color: theme.palette.blue.main }}
                        size="large"
                        onClick={() => setInfoDialogVisible(true)}
                        aria-label="More information"
                    >
                        <InfoCircleIcon fontSize="inherit" />
                    </IconButton>
                </Tooltip>
            </div>
            <UploadInfoDialog
                open={infoDialogVisible}
                onClose={() => setInfoDialogVisible(false)}
                acceptedTypes={ACCEPTED_FILES_EXT}
            />
            {isDragActive && (
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        backgroundColor: 'rgba(60,60,60,0.6)',
                    }}
                />
            )}
            {isPending && (
                <ArtsLoadingBox>
                    <Loader title="Uploading..." />
                </ArtsLoadingBox>
            )}
        </Box>
    );
};

export default DesktopUpload;
